module.exports = __webpack_public_path__ + "img/user.0ef742d5.svg";